import { Thread } from '@nylas/core';

const mockThreads: Thread[] = [
  {
    grant_id: 'cupzamawdetp',
    id: 'jbkzzprwgece',
    object: 'thread',
    latest_draft_or_message: {
      grantId: 'cupzamawdetp',
      date: 1647191014,
      createdAt: 1647191014,
      id: 'rilypgydzcng',
      object: 'message',
      subject: 'Meeting Discussion 1',
      from: [
        {
          email: 'alice.johnson@example.com',
          name: 'Alice Johnson',
        },
      ],
      to: [
        {
          email: 'bob.smith@example.com',
          name: 'Bob Smith',
        },
      ],
      body: 'Hi, I wanted to follow up on our last meeting. Can we schedule a call to discuss the next steps?',
      folders: ['INBOX'],
    },
    has_attachments: false,
    has_drafts: false,
    earliest_message_date: 1647191014,
    latest_message_received_date: 1657830617,
    latest_message_sent_date: 1677116518,
    participants: [
      {
        email: 'alice.johnson@example.com',
        name: 'Alice Johnson',
      },
      {
        email: 'bob.smith@example.com',
        name: 'Bob Smith',
      },
      {
        email: 'charlie.brown@example.com',
        name: 'Charlie Brown',
      },
    ],
    snippet: 'Hi, I wanted to follow up on our last meeting...',
    starred: false,
    subject: 'Meeting Discussion 1',
    unread: false,
    message_ids: ['yigwmulzulqb', 'otfnnzkxsahw', 'rgauqzadeghn', 'njqgquuuzwqj', 'ihnrbmdjpdcy'],
    draft_ids: ['flphjrvuvezu', 'anezheuvhpxt', 'crxwdrabnutz'],
    folders: ['INBOX'],
  },
];

export default mockThreads;
